// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"df1cf85c","787":"43d88a3b"}[chunkId] + ".chunk.js";
};